import React from "react";
import { RiTwitterXFill } from "react-icons/ri";
import { IoLogoLinkedin, IoLogoInstagram } from "react-icons/io5";
import { FaFacebook } from "react-icons/fa";
import logo from "../assets/logos/logo.png"; // ✅ added to use the logo in the footer

const Footer = () => {
  return (
    <footer className="py-12 bg-black border-t border-gray-900">
      <div className="container px-6 mx-auto">
        <div className="grid gap-8 mb-8 md:grid-cols-4">
          {/* Brand Section */}
          <div className="md:col-span-1">
            <div className="flex items-center mb-4 space-x-3">
              {/* ✅ replaced round green ball with logo */}
              <img
                src={logo}
                alt="Synnovara Logo"
                className="object-contain w-10 h-10 rounded-full bg-[#8ad11c]"
              />
              <div>
                <h3 className="text-xl font-bold text-white">Synnovara</h3>
                <p className="text-xs text-lime-400">Innovation Hub</p>
              </div>
            </div>
            <p className="text-sm text-gray-400">
              Transforming ideas into digital reality with cutting-edge
              solutions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="mb-4 font-bold text-white">Quick Links</h4>
            <div className="space-y-2">
              {["Home", "Project", "Services", "About", "Contact"].map(
                (link) => (
                  <a
                    key={link}
                    href={link === "Home" ? "/" : `/${link}`}
                    className="block text-sm text-gray-400 transition-colors hover:text-lime-400"
                  >
                    {link}
                  </a>
                )
              )}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="mb-4 font-bold text-white">Our Services</h4>
            <div className="space-y-2">
              {[
                "Web Development",
                "WordPress Development",
                "UI/UX Design",
                "E-commerce Solutions",
                "Mobile App Development",
                "AI Integration",
              ].map((service) => (
                <p key={service} className="text-sm text-gray-400">
                  {service}
                </p>
              ))}
            </div>
          </div>

          {/* Connect With Us */}
          <div>
            <h4 className="mb-4 font-bold text-white">Connect With Us</h4>
            <div className="flex mb-4 space-x-4">
              <a
                href="https://www.linkedin.com/company/synnovara/posts/?feedView=all"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-10 h-10 transition-all duration-300 bg-gray-900 rounded-full hover:bg-lime-400 hover:text-black"
              >
                <IoLogoLinkedin className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/synnovara_solutions/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-10 h-10 transition-all duration-300 bg-gray-900 rounded-full hover:bg-lime-400 hover:text-black"
              >
                <IoLogoInstagram className="w-5 h-5" />
              </a>
              <a
                href="https://x.com/synnovara?mx=2"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-10 h-10 transition-all duration-300 bg-gray-900 rounded-full hover:bg-lime-400 hover:text-black"
              >
                <RiTwitterXFill className="w-5 h-5" />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61565543078791&mibextid=ZbWKwL"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-10 h-10 transition-all duration-300 bg-gray-900 rounded-full hover:bg-lime-400 hover:text-black"
              >
                <FaFacebook className="w-5 h-5" />
              </a>
            </div>
            <a
              href="https://linktr.ee/Synnovara"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm transition-colors text-lime-400 hover:text-lime-300"
            >
              All Contact Links →
            </a>
          </div>
        </div>

        <div className="pt-8 text-center border-t border-gray-900">
          <p className="text-sm text-gray-500">
            © {new Date().getFullYear()} Synnovara. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
